import {
  SocialName,
  TradeToEarnCampaignWithPrivateFields,
  PublicationStatus,
  REWARD_NETWORK,
  TradingCampaignRules,
  TokenPairSymbol,
} from "@cede/types";
import { DEFAULT_REWARD_CHAIN_ID } from "../defi/blockchains";
import { randomId } from "../random";
import Decimal from "decimal.js";

// TODO: replace by TradeToEarnCampaignBuilder
export class CampaignFactory {
  private campaign: TradeToEarnCampaignWithPrivateFields;

  constructor() {
    this.campaign = {
      status: "live",
      chainId: DEFAULT_REWARD_CHAIN_ID,
      id: parseInt(randomId()),
      name: "Mock Campaign",
      startedAt: new Date(),
      endedAt: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30),
      createdAt: new Date(),
      updatedAt: new Date(),
      privateCampaignUtms: [],
      title: "Mock Campaign Title",
      tokenSymbol: "MOCK",
      prizePool: "10000",
      prizePoolToken: "MOCK",
      publishedAt: new Date(),
      production: true,
      networkReward: [REWARD_NETWORK.ARBITRUM_ONE, REWARD_NETWORK.ETHEREUM, REWARD_NETWORK.OPTIMISM],
      rewardToken: "USDT",
      visibility: "public",
      epochGroups: [],
      descriptions: [],
      icon: "",
      campaignPartners: [],
      rewardVaultAddress: "0x1234567890",
      alertSelfTrading: false,
      slippageThreshold: 1.5,
      maxTradeAmountUSD: 100,
      epochs: [],
      requiredSocialAccounts: [],
      currentEpoch: null,
      nextEpoch: null,
      isNew: false,
      publicationStatus: PublicationStatus.PUBLISHED,
      exchangeIds: [],
      authorizedParticipants: [],
      exclusiveOptInParticipants: [],
      pairSymbols: [],
      spreadThresholdAlert: 2,
      autopilotSpreadThreshold: 2,
      autopilotCaptchaEnabled: false,
      disableHyperliquidRefereeCheck: false,
      winnerHubUserId: null,
      winnerNickname: null,
      didCurrentUserWin: false,
    };
  }

  withEpochs(count: number, opts: { maxDefiAddressesByExchangeUserId?: number; start?: Date; end?: Date } = {}) {
    const DAY_MS = 1000 * 60 * 60 * 24;
    const now = new Date();
    const newEpochs = Array.from({ length: count }, (_, i) => ({
      id: parseInt(randomId()),
      rule: {
        rule: TradingCampaignRules.PROPORTIONAL,
        data: {
          totalReward: new Decimal(1000),
          kingOfTheHill: false,
        },
      },
      start: opts.start ?? new Date(now.getTime() + i * DAY_MS),
      end: opts.end ?? new Date(now.getTime() + (i + 1) * DAY_MS),
      rewardTokenAddress: "0x0000000000000000000000000000000000000000",
      maxDefiAddressesByExchangeUserId: opts.maxDefiAddressesByExchangeUserId ?? 1,
      activeEpochId: parseInt(randomId()),
      epochGroupId: "",
      expectedTradedVolume: 0,
    }));
    this.campaign.epochs = [...this.campaign.epochs, ...newEpochs];
    // Set currentEpoch to the first epoch that contains "now"
    this.campaign.currentEpoch = this.campaign.epochs.find((e) => e.start <= now && e.end >= now) ?? null;
    return this;
  }

  withCurrentEpoch(epochIndex: number) {
    this.campaign.currentEpoch = this.campaign.epochs[epochIndex] ?? null;
    return this;
  }

  withSocialAccountsRequired(socialAccounts: SocialName[]) {
    this.campaign.requiredSocialAccounts = socialAccounts;
    return this;
  }

  withTokenSymbol(tokenSymbol: string) {
    this.campaign.tokenSymbol = tokenSymbol;
    return this;
  }

  withauthorizedParticipants(authorizedParticipants: string[]) {
    this.campaign.authorizedParticipants = authorizedParticipants;
    return this;
  }

  withPairSymbols(pairSymbols: TokenPairSymbol[]) {
    this.campaign.pairSymbols = pairSymbols;
    return this;
  }

  get(): TradeToEarnCampaignWithPrivateFields {
    return this.campaign;
  }
}
